import { FormEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Col, Form, Row } from "react-bootstrap"
import { getUrlSearchParams } from "../../urlParams"
import { ApiEndpoints, reqGetNew, reqPatch, reqPostNew, reqPut } from "../../../config/apiClient"
import removeAllErrorMsg from "../../../components/funcRemoveAllErros"
import funcSleep from "../../../components/funcSleep"
import LoadingModal from "../../../components/loadingModal"
import { defineValueInInput } from "../../../components/funcForInput"

function InsumosProdutosFormPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [unidades, setUnidades] = useState<any[]>([])
    const [dados, setDados] = useState<any>({})

    useEffect(() => {
        document.title = "Cadastrar Produto Insumo | OB PORTUS"
        loadingPage()
        // eslint-disable-next-line
    }, [])
    async function loadingPage() {
        const apiUnidades = await reqGetNew(ApiEndpoints.insumosUnidades)
        if (apiUnidades.status === 200) {
            setUnidades(apiUnidades.data)
        } else { return; }

        const urlDados = getUrlSearchParams()
        const id = urlDados.get("id")
        if (id !== null) {
            getDados(Number(id))
            document.title = "Editar Produto Insumo | OB PORTUS"
        }
    }
    async function getDados(id: number) {
        setLoading(true)
        const dadosId = {
            id_produto: Number(id)
        }
        const api = await reqPostNew(ApiEndpoints.insumosProduto, dadosId)
        if (api.status === 200) {
            const registro: any = api.data
            setDados(registro)
            defineValueInInput('id_produto', registro.id_produto)
            defineValueInInput('descricao', registro.descricao)
            defineValueInInput('id_unidade_padrao', registro.id_unidade_padrao.id_unidade)
            defineValueInInput('status', registro.situacao)
            document.title = `Editar ${registro.descricao} | OB PORTUS`
        }
        setLoading(false)
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()
        removeAllErrorMsg()

        const form: any = event.target
        let formValidado = true
        let dadosForm = {
            id_produto: Object.values(dados).length === 0 ? 0 : dados.id_produto,
            descricao: form.descricao.value,
            id_unidade_padrao: Number(form.id_unidade_padrao.value),
            situacao: Number(form.status.value),
        }

        // cod_serv: Object.values(clienteDados).length > 0 ? clienteDados?.cod_serv : form.cod_serv.value,
        //     descricao: form.descricao.value,
        //     iss_incidencia_municipio_prestador: form.iss.value,

        if (dadosForm.descricao === "") {
            form.descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dadosForm.id_unidade_padrao === 0) {
            form.id_unidade_padrao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dadosForm.id_produto! <= 0 || dadosForm.id_produto === null) {
            dadosForm.id_produto = null
        }

        console.info(dadosForm)

        if (!formValidado) {
            return
        }
        if (Object.values(dados).length === 0) {
            cadastrar(dadosForm)
        }
        if (Object.values(dados).length > 0) {
            editar(dadosForm)
        }

    }

    async function cadastrar(dados: any) {
        setLoading(true)
        const api = await reqPut(ApiEndpoints.insumosProdutoCadastrar, dados)
        if (api.status === 201) {
            console.log(api.data)
            toast.success('Produto cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await funcSleep(500)
            window.location.assign(`/insumos/produtos`)
        }
        setLoading(false)
    }
    async function editar(dados: any) {
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.insumosProdutoEditar, dados)
        if (api.status === 200) {
            console.log(api.data)
            toast.success('Produto editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await funcSleep(500)
            window.location.assign(`/insumos/produtos`)
        }
        setLoading(false)
    }
    async function handleExcluirTipo() {
        if (!window.confirm('Tem certeza que deseja excluir o Produto?')) {
            return
        }
        const dadosAux = {
            id_produto: dados.id_produto,
        }
        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.insumosProdutoDeletar, dadosAux)
        if (api.status === 200) {
            console.log(api.data)
            toast.success('Produto excluído com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await funcSleep(500)
            window.location.assign(`/insumos/produtos`)
        }
        setLoading(false)
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event: any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
                <h1 id="titleMain">Insumos Produto</h1>
                <Button variant="secondary" onClick={() => { window.location.assign(`/insumos/produtos`) }}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formInsumosProduto' onSubmit={handleSubmit} noValidate>
                <Row className="mb-15-forms">
                    <Col className="col-1">
                        <Form.Group>
                            <Form.Label>Cod. Produto:</Form.Label>
                            <Form.Control name='id_produto' type="number" id='id_produto' placeholder="" readOnly disabled />
                        </Form.Group>
                    </Col>
                    <Col className="col-5">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name='descricao' type="text" id='descricao' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Unidade Padrão:</Form.Label>
                            <Form.Select name="id_unidade_padrao" id="id_unidade_padrao" aria-label="">
                                <option value="0">Não selecionado</option>
                                {
                                    unidades.map((unidade, idx, arr) => {
                                        return (
                                            <option key={idx} value={unidade.id_unidade}>
                                                {unidade.descricao}
                                            </option>
                                        )
                                    })
                                }
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe a unidade padrão!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Status:</Form.Label>
                            <Form.Select name="status" id="status" aria-label="">
                                <option value="1">Ativo</option>
                                <option value="0">Desativado</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe o Status!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                {
                    Object.values(dados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(dados).length > 0 &&
                    <Button variant="success" type="submit" disabled={loading} style={{ marginRight: '10px' }}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                }

                {
                    Object.values(dados).length > 0 &&
                    <Button variant="danger" disabled={loading} style={{ marginRight: '10px' }} onClick={() => { handleExcluirTipo() }}>{loading ? 'Aguarde ...' : 'Deletar'}</Button>
                }
            </Form>
        </div>
    )
}

export default InsumosProdutosFormPage